import dayjs, { Dayjs } from 'dayjs';

const YEAR_SECOND_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

/**
 * 时间格式化到 年秒
 *  格式为 2025-01-17 22:06:40
 */
export const timeFormatToYearSecond = (time: string | Dayjs) => {
  if (!time) {
    return '';
  }

  if (dayjs.isDayjs(time)) {
    return time?.format(YEAR_SECOND_TIME_FORMAT);
  }

  return dayjs(time).format(YEAR_SECOND_TIME_FORMAT);
};

/**
 * 时间格式化到 年日
 *  格式为 2025-01-17
 */
export const timeFormatToYearDate = (time: string) => (time ? dayjs(time).format('YYYY-MM-DD') : '');

/** 搜索列表的传给后端的格式 */
const SEARCH_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

/** 格式化给后端的入参(结束的日期需要加1天减1s) */
export const findSearchDateFormatToBackend = (config: { isEnd: boolean; date?: Dayjs }) => {
  const { isEnd, date } = config;
  if (!date) {
    return undefined;
  }
  return isEnd ? dayjs(date).endOf('date').format(SEARCH_DATE_FORMAT) : dayjs(date).startOf('date').format(SEARCH_DATE_FORMAT);
};

/**
 * 将传入的视频时长格式化成分秒,格式 为 00:00
 * @param duration 视频时长(s)
 */
export const formatDurationToMinSencods = (originDuration = 0) => {
  const duration = Math.floor(originDuration);
  const minutes = Math.floor(duration / 60);
  const seconds = duration % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};

/** 生成最近一周的时间数组 */
export const createLastWeekDate = (): [Dayjs, Dayjs] => [dayjs().subtract(6, 'day'), dayjs()];

/** 格式化时间入参为时和分钟,输出为 HH:mm */
export const formatTimeToHHmm = (config: { hour?: number; minute?: number }) => {
  const { hour = 0, minute = 0 } = config;
  return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
};

/** 限制时间: 一个月之前到今天,返回格式为[Dayjs, Dayjs] */
export const limitTimeToMonth = () => [dayjs().subtract(1, 'month'), dayjs()];

/** 更新时间展示:当天的显示“时：分”，非当天的显示日期“08/04”，非当年的显示年月日“2024/08/01” */
export const formatUpdateTime = (time = '') => {
  if (!time) {
    return '';
  }
  const now = dayjs();
  const updateTime = dayjs(time);
  // 当天的显示“时：分”
  if (now.isSame(updateTime, 'day')) {
    return updateTime.format('HH:mm');
  }
  // 非当天 && 当年的显示日期“08/04”
  if (now.isSame(updateTime, 'year')) {
    return updateTime.format('MM/DD');
  }
  // 非当年的显示年月日“2024/08/01”
  return updateTime.format('YYYY/MM/DD');
};
